import { render, staticRenderFns } from "./FrameworkWrapper.vue?vue&type=template&id=2a2b866e"
import script from "./FrameworkWrapper.vue?vue&type=script&lang=js"
export * from "./FrameworkWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports